import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';

function ErrorModal(props) {
    const { errorModal, setErrorModal, errorMessage , errorType, calledFrom} = props;
    const { t } = useTranslation();

    const errorModalHandler = () => {
        props.handleErrorModal(false);
        return props.closeHandler ? props.closeHandler : false;
    }
    // console.log("Reached", errorModal, calledFrom)
    return (
        <>
            <Dialog
                open={errorModal}
                onClose={() => {
                    setErrorModal(false);
                    return props.closeHandler ? props.closeHandler : false;
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className='dialog-header'>
                    <div className="title" style={{textTransform:'capitalize'}}>{errorType ? errorType : t('ERROR')}</div>
                </DialogTitle>

                <DialogContent 
                    className='modal-content' 
                    dividers
                >
                    {errorMessage && errorMessage?.split('\\n').map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            {index < errorMessage?.split('\\n').length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </DialogContent>

                <DialogActions>
                    <Button
                        size="small"
                        onClick={props.OkHandler || errorModalHandler}
                        variant={"outlined"}
                    >
                        {t("BTN_OK")}
                    </Button>
                    {errorType === t('BOX_CONFIRM') && (
                        <Button
                        size="small"
                        onClick={errorModalHandler}
                        variant={"outlined"}
                    >
                        {t("CANCEL")}
                    </Button>
                    )}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ErrorModal